import Cookies from "js-cookie";

/** A cookie readable by script in this browser, decoded, or undefined. */
export const getBrowserCookie = (name: string): string | undefined =>
  Cookies.get(name);
